import * as React from "react";

import { IMenuItem } from "../../IMenuItem";
import { UndecoratedList } from "./atoms/UndecoratedList";
import { MenuGroup } from "./MenuGroup";

interface Props {
  menuItems?: IMenuItem[];
  level?: number;
  expandedIndex?: number[];
  toggleExpandFn?: (level: number, index: number) => void;
  shouldShow?: boolean;
}

export const Submenus = ({
  menuItems = [],
  level = 0,
  expandedIndex = [0],
  toggleExpandFn = () => {},
  shouldShow = false,
}: Props) => {
  return (
    <UndecoratedList className={shouldShow ? "" : "hide"}>
      {menuItems &&
        menuItems.map((menuItem, index) => (
          <MenuGroup
            shouldShow={false}
            menuItem={menuItem}
            level={level}
            key={index}
            expanded={Boolean(index === expandedIndex[level - 1])}
            expandedIndex={expandedIndex}
            toggleExpandFn={toggleExpandFn}
            toggleExpand={() => toggleExpandFn(level, index)}
          />
        ))}
    </UndecoratedList>
  );
};
